class PostcodeInput extends HTMLElement {
  static POSTCODE_PATTERN = /^[1-9]\d{3}$/;

  constructor() {
    super();
    this.input = document.createElement('input');
    this.input.type = 'text';
    this.input.classList.add('input');
    this.input.autocomplete = 'postal-code';
    this.input.inputMode = 'numeric';
    this.input.maxLength = 4;
    this.errorMessage = document.createElement('span');
    this.errorMessage.classList.add('form-error-message');
    this.errorMessage.setAttribute('role', 'alert');
    this.errorMessage.setAttribute('aria-live', 'polite');
  }

  _setValidity(message) {
    this.input.setCustomValidity(message);
    this.errorMessage.setAttribute('aria-hidden', message ? 'false' : 'true');

    if (message) {
      clearTimeout(this._errorClearTimer);
      this.errorMessage.textContent = message;
      this.classList.add('has-error');
      return;
    }

    this.classList.remove('has-error');
    clearTimeout(this._errorClearTimer);
    this._errorClearTimer = setTimeout(() => {
      if (!this.classList.contains('has-error')) {
        this.errorMessage.textContent = '';
      }
    }, 300);
  }

  connectedCallback() {
    if (this.hasAttribute('name')) this.input.name = this.getAttribute('name');
    if (this.hasAttribute('required')) this.input.required = true;
    if (this.hasAttribute('placeholder')) this.input.placeholder = this.getAttribute('placeholder');
    if (this.hasAttribute('value')) this.input.value = this.getAttribute('value');

    this.appendChild(this.input);
    this.appendChild(this.errorMessage);

    this.input.addEventListener('input', () => {
      this.input.value = this.input.value.replace(/\D/g, '').slice(0, 4);
      this._setValidity('');
    });

    this.input.addEventListener('blur', () => {
      const value = this.input.value.trim();

      if (!value) {
        if (this.input.required) {
          this._setValidity(this.dataset.errorRequired || 'Postcode is required');
        }
        return;
      }

      if (!PostcodeInput.POSTCODE_PATTERN.test(value)) {
        this._setValidity(this.dataset.errorInvalid || 'Wrong postcode format');
        return;
      }

      this._setValidity('');
    });
  }
}

customElements.define('postcode-input', PostcodeInput);
